import React from 'react'
import Layout from './src/components/layout'
import { COMPTA_BASE_PATH } from './src/compta/utils/routes.utils'

const isComptaRoute = pathname => pathname.startsWith(COMPTA_BASE_PATH)

// Le site vitrine est habillé par son Layout (header + footer).
// L'application de comptabilité, elle, porte sa propre mise en page antd.
export const wrapPageElement = ({ element, props }) =>
  isComptaRoute(props.location.pathname) ? (
    element
  ) : (
    <Layout {...props}>{element}</Layout>
  )
